import { gql } from '@apollo/client';

export const GENERATE_AND_SEND_QUOTE = gql`
  mutation GenerateAndSendQuote($contactInformation: ContactInformationInput!, $selectedItems: [SelectedItemInput]!, $paymentMethod: PaymentMethodInput!) {
    generateAndSendQuote(contactInformation: $contactInformation, paymentMethod: $paymentMethod, selectedItems: $selectedItems) {
      success
    }
  }
`;
